import Footer from "../organisms/fooder";
import Header from "../organisms/header";

export default function DefaultPage({ children }) {
  return (
    <>
      <Header />
      <div
        style={{
          position: "relative",
          // height: "100vh",
          // overflow: "auto",
        }}
      >
        <div
          style={{
            backgroundImage: "url(/images/Background.jpg)",
            backgroundSize: "cover",
            backgroundRepeat: "repeat",
            backgroundPosition: "center",
            height: "100%",
            width: "100%",
            position: "absolute",
            top: 0,
            left: 0,
            opacity: "0.2",
            zIndex: -1,
          }}
        />
        <div style={{ position: "relative", zIndex: 1 }}>{children}</div>
      </div>
      <Footer />
    </>
  );
}
